const routes = {
  // Root
  root: '/',
  lemMS: '/media_superior',
  lemU: '/universitarios',
  repositorio: '/repositorio',
  contacto: '/contacto',
  perfiles: '/egresados-perfiles-profesionales',
};

export default routes;
